import { z } from "zod";

import { RoomDummyInputSchema } from "@/lib/zod/__generated__/validation-schema";

import {
	kidsPolicyZodSchema,
	s3ObjectZodSchema,
} from "@/components/features/_shared/validation-schema/validation-schema";

import type { ZodError } from "zod";

export const dummyRoomInputZodSchema = RoomDummyInputSchema.extend({
	name: z.string().min(1).max(30),
	mainKeyVisual: s3ObjectZodSchema,

	capacityPeopleMaximum: z.number().int().min(1).max(100),
	capacityAdultMaximum: z.number().int().min(1).max(100),
	capacityKidsMaximum: z.number().int().min(0).max(100),

	maxRoomNum: z.number().int().min(1).max(1_000),

	kidsPolicy: kidsPolicyZodSchema.nullish(),
});

export type DummyRoomInputZodSchemaType = z.infer<typeof dummyRoomInputZodSchema>;

export type DummyRoomInputZodParseErrorType = ZodError<DummyRoomInputZodSchemaType>;
